import React from 'react';
import { Box, Paper, Typography, Divider, Grid, Button } from '@mui/material';
import DateDropdown from '../../layout/form/inputs/date/DateDropdown';
import MontantDropdown from '../../layout/form/inputs/number/MontantDropdown';

const DecomptesFilters = ({ filters, onChange, onSearch, onReset }) => (
    <Box sx={{ p: 1.5, borderRadius: '8px', width: '100%' }}>
        <Paper sx={{ padding: 5 }}>
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                Mes décomptes de prestations
            </Typography>
            <Divider sx={{ borderColor: '#EF595D', my: 1, width: '7%', borderWidth: '2px' }} />
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <DateDropdown
                        startDate={filters.from}
                        endDate={filters.to}
                        onChangeStart={e => onChange({ ...filters, from: e })}
                        onChangeEnd={e => onChange({ ...filters, to: e })}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <MontantDropdown
                        min={filters.min}
                        max={filters.max}
                        onChangeMin={e => onChange({ ...filters, min: e.target.value })}
                        onChangeMax={e => onChange({ ...filters, max: e.target.value })}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Button variant="contained" size="small" color="primary" onClick={onSearch} sx={{ textTransform: 'none'/*, height: 53*/ }}>
                                Rechercher
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="contained" size="small" color="error" onClick={onReset} sx={{ /*, height: 53*/ textTransform: 'none' }}>
                                Effacer
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    </Box>
);

export default DecomptesFilters;
